import React from 'react'
import {
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'
import type { ObjectMenuCommands } from '../types/menu-items'
import { DesktopCommandItem } from './desktop-command-item'
import { DesktopSubmenu } from './desktop-submenu'

type DesktopObjectMenuProps = {
  commands: ObjectMenuCommands
  closeMenu: () => void
}

export const DesktopObjectMenu: React.FC<DesktopObjectMenuProps> = ({ commands, closeMenu }) => {
  return (
    <DesktopSubmenu label="Object">
      {commands.grouping.map((command, index) => (
        <DesktopCommandItem key={index} command={command} closeMenu={closeMenu} />
      ))}
      <DropdownMenuSeparator />
      {commands.locking.map((command, index) => (
        <DesktopCommandItem key={index} command={command} closeMenu={closeMenu} />
      ))}
      <DropdownMenuSeparator />
      <DesktopCommandItem command={commands.convertTextToShape} closeMenu={closeMenu} />
      <DropdownMenuSeparator />
      {/* AC-2: Object > Path Operations > Text on Path. Nested-sub structure copied from
          View > Show Grid (desktop-view-menu.tsx) — the only other submenu-inside-a-submenu here.
          Edit Path and Clipping Path deliberately stay where they already live. */}
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>Path Operations</DropdownMenuSubTrigger>
        <DropdownMenuSubContent
          sideOffset={5}
          className="w-56 max-w-[90vw]"
          data-text-edit-keepalive=""
        >
          <DesktopCommandItem command={commands.textOnPath} closeMenu={closeMenu} />
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    </DesktopSubmenu>
  )
}
